import Box from '@mui/material/Box';

const GRID_STYLES = {
    dark: {
        backgroundColor: '#0C1526',
        backgroundImage: [
            'linear-gradient(to bottom, rgb(67 191 236 / 8%) 1px, transparent 1px)',
            'linear-gradient(to right, rgb(67 191 236 / 8%) 1px, transparent 1px)',
            'linear-gradient(to bottom, rgb(35 174 226 / 18%) 1px, transparent 1px)',
            'linear-gradient(to right, rgb(35 174 226 / 18%) 1px, transparent 1px)',
        ].join(', '),
        backgroundSize: '18px 18px, 18px 18px, 72px 72px, 72px 72px',
        backgroundPosition: '-1px -1px',
    },
    light: {
        backgroundColor: '#fbfaf7',
        backgroundImage: [
            'linear-gradient(to bottom, rgb(67 191 236 / 15%) 1px, transparent 1px)',
            'linear-gradient(to right, rgb(67 191 236 / 15%) 1px, transparent 1px)',
            'linear-gradient(to bottom, rgb(35 174 226 / 32%) 1px, transparent 1px)',
            'linear-gradient(to right, rgb(35 174 226 / 32%) 1px, transparent 1px)',
        ].join(', '),
        backgroundSize: '18px 18px, 18px 18px, 72px 72px, 72px 72px',
        backgroundPosition: '-1px -1px',
    },
};

export default function BlueprintGrid({ variant = 'dark', sx, children, ...props }) {
    return (
        <Box sx={{ ...GRID_STYLES[variant], ...sx }} {...props}>
            {children}
        </Box>
    );
}
